import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body } from '@swyftx/aviary/atoms/Typography';

import { cn } from '@shared/utils/lib/ui';

import { Check } from 'lucide-react';

export const Indicator = ({
  isActive,
  isComplete,
  stepNumber,
}: {
  isActive: boolean;
  isComplete: boolean | 0;
  stepNumber?: number;
}) => {
  const bgColor = isActive
    ? 'bg-color-background-primary'
    : isComplete
    ? 'bg-color-background-primary-subtle'
    : 'bg-color-background-neutral';

  const dimensions = stepNumber ? 'h-32 w-32' : 'h-16 w-16';

  return (
    <FlexLayout
      alignItems='center'
      justifyContent='center'
      className={cn(bgColor, dimensions, 'rounded-[50%] transition-colors')}
    >
      {stepNumber && isComplete ? (
        <Check
          className={cn(
            'h-16 w-16',
            isActive && isComplete ? 'stroke-color-background-neutral' : 'stroke-color-background-primary',
          )}
        />
      ) : (
        <Body color={isActive ? 'inverse' : 'primary'}>{stepNumber || ''}</Body>
      )}
    </FlexLayout>
  );
};
